// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import ElementUI from 'element-ui';
import './sass/base/elementUI.scss'
import './sass/base/antDesignVue.less'
// import 'ant-design-vue/dist/antd.less'
import App from './App'
// import VueCropper from 'vue-cropper'
import store from './store'
import router from './router/index.js'
import http from './api/ajax.js' //ajax请求
import './api/tools.js' //工具
import popup from './api/popup.js' //弹窗
import regulars from './api/regulars.js' //弹窗
import config from './api/common.js' //公共变量
import weixin from './api/weixin.js' //微信分享
import title from 'vue-wechat-title' //标题更新
import * as filter from './api/filter.js' //公共过滤器
if(config.ene != 1){
    Vue.config.devtools = true;//谷歌调试开关
}
import '@vant/touch-emulator';
import 'vant/lib/index.css';
import { Switch } from 'vant';
import { Picker } from 'vant';
import { Popup } from 'vant';
import { Stepper  } from 'vant';
import './sass/main.scss'
Vue.use(Switch);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Stepper);
Vue.use(ElementUI);

import emptyBox from './components/emptyBox';
Vue.component("emptyBox", emptyBox);
import {DatePicker,TimePicker,TreeSelect,Tree } from 'ant-design-vue';
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(TreeSelect)
Vue.use(Tree)
// Vue.use(VueCropper)
Vue.use(regulars)
Vue.use(popup)
Vue.use(filter)
Vue.use(title)
Vue.use(config)
    // Vue.use(Clipboard)
const filters = filter.filter;
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.directive('title', {
    inserted: function(el, binding) {
        document.title = binding.value;
    },
    update: function(el, binding) {
        document.title = binding.value;
    }
});
// 将API方法绑定到全局
// Vue.prototype.$ajax = ajax
Vue.prototype.$http = http;
// Vue.prototype.$tool = tool;
Vue.prototype.$weixin = weixin;
Vue.prototype.$notice = popup;
Vue.prototype.$config = config;
Vue.prototype.$regular = regulars;
Vue.prototype.$element = ElementUI;
Vue.prototype.$bus = new Vue();


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
